import React from 'react'
import styled from 'styled-components'
import { sortableHandle } from 'react-sortable-hoc'

const Handle = styled.div`
  display: inline-block;
  background: rgba(0, 0, 0, 0);
  ${({disable}) => !disable && `
    &:hover {
    }
  `}
`

const SortableDragHandle = sortableHandle(({children, disable}) =>
  (<Handle disable={disable}>{children}</Handle>)
)

export default SortableDragHandle
